// src/cert/internal-auditor.js
import React from 'react';
import ApplyForm from '../components/ApplyForm';
import './CertPage.css';

const InternalAuditor = () => {
  return (
    <div className="cert-page">
      <div className="cert-header">
        <h1>Internal Auditor प्रशिक्षण</h1>
        <p>प्रमाणन व्यवस्थापन प्रणाली आंतरिक ऑडिटर प्रशिक्षण</p>
      </div>

      <div className="cert-content">
        <section>
          <h2>Internal Auditor प्रशिक्षण म्हणजे काय?</h2>
          <p>
            Internal Auditor प्रशिक्षण हे <strong>ISO 9001, 14001, 45001, 27001, 22000</strong> 
            सारख्या मानकांसाठी <strong>संस्थेच्या आंतरिक ऑडिट्स</strong> 
            करण्यासाठी आवश्यक कौशल्ये शिकवते. 
            हे <strong>प्रक्रिया सुधारणा, अनुपालन तपासणी आणि तयारी</strong> 
            साठी उपयुक्त आहे.
          </p>
        </section>

        <section>
          <h2>प्रमुख फायदे</h2>
          <ul>
            <li>संस्थेच्या प्रक्रियांचे स्वतः मूल्यमापन करू शकता</li>
            <li>बाह्य ऑडिटसाठी (Certification Audit) तयारी</li>
            <li>खर्च कमी — बाह्य ऑडिटरची गरज कमी</li>
            <li>प्रक्रिया सुधारणा आणि जोखीम व्यवस्थापन</li>
            <li>संस्थेच्या कर्मचाऱ्यांना प्रमाणपत्र — करिअर वाढ</li>
          </ul>
        </section>

        <section className="apply-section">
          <h2>Internal Auditor प्रशिक्षणासाठी अर्ज करा</h2>
          <ApplyForm certification="Internal Auditor Training" />
        </section>
      </div>
    </div>
  );
};

export default InternalAuditor;